import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import PageTitle from '../../components/Common/PageTitle'
import styles from './AgentView.module.scss'
import TableAgentUsers from '../../components/TableAgentUsers/TableAgentUsers'
import TableAgentOrganizations from '../../components/TableAgentOrganizations/TableAgentOrganizations'
import AgentReferral from '../../components/AgentReferral/AgentReferral'
import CommissionStatements from '../../components/CommissionStatements/CommissionStatements'

const AgentView = () => {
  return (
    <div className='py-4'>
      <PageTitle title='' subtitle='Creating user with agent' className={styles.title} />
      <h3 className={styles.header}>Agent View</h3>
      <div className={styles.usersAndAccountsWrapper}>
        <AgentReferral />
        <Tabs>
          <TabList>
            <Tab>Users</Tab>
            <Tab>Organizations</Tab>
            <Tab>Commission statements</Tab>
          </TabList>
          <TabPanel>
            <TableAgentUsers />
          </TabPanel>
          <TabPanel>
            <TableAgentOrganizations />
          </TabPanel>
          <TabPanel>
            <CommissionStatements />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

export default AgentView
